export default {
  installationSection: {
    title: {
      fr: "L'expérience d'installation réinventée",
      en: "A Smarter Way to Install",
    },
    subtitle: {
      fr: "Des modules tout en un.",
      en: "One module. Endless possibilities.",
    },
    description: {
      fr: "Polynhome propose une gamme rationnalisée de modules connectés multifonctions. Grâce à un sélecteur physique intégré, chaque module peut être configuré au moment de la pose pour remplir la fonction souhaitée\n variateur, volet roulant, radiateur, portail, interrupteur, offrant ainsi une flexibilité maximale lors de l'installation. ",
      en: "Polynhome introduces a streamlined range of multifunction smart modules. With a built-in physical selector, each module adapts on site to the required use\n lighting dimmer, roller shutter, heating, gate or switch, giving installers total flexibility and simplifying every installation.",
    },
  },
};
